import * as Immutable from 'immutable';

/**
 * 画面左ハンバーガーメニュー用モジュール
 */
export interface DrawerState {
  open: boolean;
}

const initialState: DrawerState = Immutable.fromJS({
  open: false,
});

const OPEN_DRAWER = 'OPEN_DRAWER';
type OPEN_DRAWER = typeof OPEN_DRAWER;

const CLOSE_DRAWER = 'CLOSE_DRAWER';
type CLOSE_DRAWER = typeof CLOSE_DRAWER;

interface OpenDrawer {
  type: OPEN_DRAWER;
}

interface CloseDrawer {
  type: CLOSE_DRAWER;
}

type DrawerAction = OpenDrawer | CloseDrawer;

export function openDrawer(): OpenDrawer {
  return {
    type: OPEN_DRAWER,
  };
}

export function closeDrawer(): CloseDrawer {
  return {
    type: CLOSE_DRAWER,
  };
}

export default function reducer(
  state: DrawerState | undefined,
  action: DrawerAction,
): DrawerState {
  if (!state) return initialState;
  switch (action.type) {
    case OPEN_DRAWER:
      return { ...state, open: true };
    case CLOSE_DRAWER:
      return { ...state, open: false };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/drawer.ts